import { Box, BoxProps } from '@mui/material';
import jsonExport from 'jsonexport/dist';
import { Fragment, memo } from 'react';
import {
  BooleanField,
  BulkDeleteButton,
  BulkDeleteButtonProps,
  BulkExportButton,
  BulkExportButtonProps,
  Datagrid,
  DateField,
  downloadCSV,
  List,
  ReferenceManyField,
  ReferenceOneField,
  ShowButton,
  ShowView,
  SimpleShowLayout,
  SingleFieldList,
  TextField,
  TextInput
} from 'react-admin';
import AlertDateField from '../../Components/AlertDateField';
import { LoginAsButton } from '../../Components/LoginAsButton';
import PrefixedImageField from '../../Components/PrefixedImageField';
import SourceEditButton from '../../Components/SourceEditButton';
import DeactivatedDateField from '../../Components/StyledFields/DeactivatedDateField';

const CompaniesListActionToolbar = (props: BoxProps) => <Box sx={{ alignItems: 'center', display: 'flex' }}>{props.children}</Box>;
const CompaniesListBulkActions = memo((props: BulkDeleteButtonProps & BulkExportButtonProps) => (
  <Fragment>
    <BulkDeleteButton {...props} />
    <BulkExportButton {...props} />
  </Fragment>
));
const exporter = (companies: any[]) => {
  //   const data = companies.map((company) => ({
  //     ...company,
  //     backlinks: lodashGet(company, 'backlinks', []).map((backlink: unknown) => backlink.url)
  //   }));
  return jsonExport(companies, (err: Error, csv: string) => downloadCSV(csv, 'companies'));
};

// const QuickFilter = ({ label: string, source: unknown, defaultValue: unknown }) => {
//   const translate = useTranslate();
//   return <Chip sx={{ marginBottom: 1 }} label={translate(label)} />;
// };
//const companiesFilter = [<SearchInput source="q" alwaysOn />, <TextInput source="name" defaultValue="" />, <QuickFilter label="resources.companies.fields.active" source="active" defaultValue />];
const rowClick = (id: unknown, resource: unknown, record: any) => {
  if (record.commentable) {
    return 'edit';
  }
  return 'show';
};
const CompaniesPanel = () => {
  return (
    <ShowView>
      <SimpleShowLayout>
        <TextField source="id" />
        <TextField source="name" cellClassName="name" />
        <DateField source="createdAt" sortByOrder="DESC" cellClassName="createdAt" />
        <DateField source="updatedAt" sortByOrder="DESC" cellClassName="updatedAt" />
        <PrefixedImageField source="logoId" cellClassName="logoId" prefix={'https://res.cloudinary.com/dyz7kja60'} />
      </SimpleShowLayout>
    </ShowView>
  );
};

const companiesFilter = [<TextInput label="Company Name" source="name" alwaysOn />, <TextInput source="id" defaultValue="" alwaysOn />, <TextInput source="uuid" defaultValue="" alwaysOn />];

const CompaniesList: React.FC = () => {
  return (
    <List filters={companiesFilter} sort={{ field: 'id', order: 'DESC' }} exporter={exporter}>
      <Datagrid bulkActionButtons={<CompaniesListBulkActions />} rowClick={rowClick} expand={CompaniesPanel} optimized sx={{ image: { maxHeight: '1rem' } }}>
        <TextField source="id" />
        <TextField source="name" cellClassName="name" />
        <DateField source="createdAt" sortByOrder="DESC" cellClassName="createdAt" />
        <DateField source="updatedAt" sortByOrder="DESC" cellClassName="updatedAt" />
        <BooleanField source="active" sortable={false} />
        <DeactivatedDateField source="deactivatedAt" sortByOrder="DESC" cellClassName="deactivatedAt" />
        <ReferenceOneField reference="customers" source="uuid" target="companyUuid" label="Subscription Status">
          <TextField source="subscriptions[0].status" />
        </ReferenceOneField>
        <ReferenceOneField reference="customers" source="uuid" target="companyUuid" label="Trail Endes">
          <AlertDateField source="subscriptions[0].trialEndedAt" />
        </ReferenceOneField>
        <ReferenceOneField reference="customers" source="uuid" target="companyUuid" label="Edit Customer">
          <SourceEditButton resource="customers" source="" label="Edit Customer" />
        </ReferenceOneField>
        <TextField source="hubspotId" sortByOrder="DESC" cellClassName="hubspotId" />
        <TextField source="gainsightId" sortByOrder="DESC" cellClassName="gainsightId" />
        <ReferenceManyField label="Owners" reference="profiles" target="company" sort={{ field: 'created_at', order: 'DESC' }} filter={{ role: 'employer' }}>
          <SingleFieldList>
            <LoginAsButton fullNameSource="user.fullName" />
          </SingleFieldList>
        </ReferenceManyField>
        <CompaniesListActionToolbar>
          <ShowButton />
        </CompaniesListActionToolbar>
      </Datagrid>
    </List>
  );
};

export default CompaniesList;
